import {
  getTotalExpiredAmount,
  getTotalIssuedAmount,
} from '@esentai/core/features/giftCertificates/selectors';
import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import Description from './component';
import styles from './styles';

const mapStateToProps = (state, { itemId }) => ({
  totalIssuedAmount: getTotalIssuedAmount(state, itemId),
  totalExpiredAmount: getTotalExpiredAmount(state, itemId),
  itemId,
});

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
)(Description);
